
  document.addEventListener("DOMContentLoaded", function() {
     $('.template-product .mount-product-page .main-product .pdp-rating-main .star-rating').addClass('hide_Secd');
    setTimeout(function() {
      var reviewElement = document.querySelector('.shopify-app-block .jdgm-all-reviews-text .jdgm-all-reviews-text__text[data-number-of-reviews]');
      
      if (reviewElement) {

        var totalReviews = reviewElement.getAttribute('data-number-of-reviews');
        var formattedReviews = Number(totalReviews).toLocaleString();

        var captionElement = document.querySelector('.template-product .mount-product-page .main-product .pdp-rating-main .star-rating .star-rating__caption');
        
        if (captionElement) {
          var localizedReviewLabel = captionElement.getAttribute('data-review-label');
          captionElement.textContent = localizedReviewLabel
            ? localizedReviewLabel.replace('__COUNT__', formattedReviews)
            : formattedReviews;
         
        }
      }
      $('.template-product .mount-product-page .main-product .pdp-rating-main .star-rating').removeClass('hide_Secd');
      $('.template-product .mount-product-page .main-product .pdp-rating-main .star-rating').addClass('show_Secd');
      $('.template-product .mount-product-page .main-product .pdp-rating-main .star-rating').css('display','block');
      
    }, 200);
    
  });
